// app/javascript/material_evaluations.js
import { hydrateLineItems } from "./material_evaluations/hydrate.js";
import { bindEvents } from "./material_evaluations/events.js";
import { calculateTotals } from "./material_evaluations/totals.js";

document.addEventListener("DOMContentLoaded", async () => {
  const form = document.getElementById("materialEvaluationForm");
  if (!form) return;

  const evaluationId = form.dataset.evaluationId;
  const materialsContainer = document.getElementById("materialsContainer");
  const machinesContainer = document.getElementById("machinesContainer");

  let materialOptions = "";
  let materialMap = {};
  let machineOptions = "";

  // Load options
  try {
    const [materialsRes, machinesRes] = await Promise.all([
      fetch("/materials.json"),
      fetch("/machines.json")
    ]);

    const materialsData = await materialsRes.json();
    const machinesData  = await machinesRes.json();

    materialOptions = materialsData.map(m => {
      materialMap[m.id] = m.unit_of_measurement;
      return `<option value="${m.id}" data-uom="${m.unit_of_measurement}">${m.name}</option>`;
    }).join("");

    machineOptions = machinesData.map(m => `<option value="${m.id}">${m.name}</option>`).join("");
  } catch (err) {
    console.error("Error loading options:", err);
  }

  // Hydrate if editing
  if (evaluationId) {
    hydrateLineItems(evaluationId, materialOptions, materialMap, materialsContainer, machineOptions, machinesContainer);
  }

  // Bind events
  bindEvents(form, materialsContainer, machinesContainer, materialOptions, materialMap, machineOptions);

  // Initial totals
  calculateTotals(materialsContainer);
});
